
export default {
  props: {
    roundtrip: {
      type: Boolean,
      default: true
    }
  }
}
